import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        // Preserve the pathname (e.g. /interpreters) that the user was originally trying to access
        // (Login builds redirect URL that includes returnTo → auth.emergentagent.com appends #session_id → we land here).
        const target = window.location.pathname && window.location.pathname !== "/" ? window.location.pathname : "/dashboard";
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (e?.response?.status === 403 && detail) {
          navigate(`/?denied=${encodeURIComponent(detail)}`, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
